import React, { useEffect } from 'react';
import queryString from 'query-string';

import WithLoading from '../../../Hoc/WithLoading';
import ReviewCarouselView from './ReviewCarouselView';
import {
  POPULAR_CRITERIA,
  POPULAR_SORT_BY,
  POPULAR_SORT_DIRECTION,
  getReviewListApi,
} from '../List/ReviewList';

const ReviewCarousel = () => {
  useEffect(() => {}, []);

  return (
    <WithLoading
      component={ReviewCarouselView}
      url={getReviewListApi.concat(
        `?${queryString.stringify({
          criteria: POPULAR_CRITERIA,
          sortBy: POPULAR_SORT_BY,
          sortDirection: POPULAR_SORT_DIRECTION,
          page: 0,
          size: 20,
          getAllImages: true,
        })}`,
      )}
      onlyLoader
      padding="12rem 7.5rem"
    />
  );
};

export default React.memo(ReviewCarousel);
